module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "clipped": ""
    },
    model: {
      value: (_vm.$store.state.menu_visible),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "menu_visible", $$v)
      },
      expression: "$store.state.menu_visible"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return [_c('v-list-item', {
      key: i,
      attrs: {
        "to": item.link,
        "active-class": "primary--text"
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1), _vm._v(" "), (item.divider) ? _c('v-divider', {
      key: item.link
    }) : _vm._e()]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "value": "true",
      "active-class": "secondary--text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.logout()
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s('exit_to_app')
    }
  })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "textContent": _vm._s('Logout')
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-app-bar', {
    attrs: {
      "fixed": "",
      "clipped-left": "",
      "app": ""
    }
  }, [_c('v-toolbar-title', [_c('v-app-bar-nav-icon', {
    staticClass: "hidden-lg-and-up",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.SHOW_MENU($event)
      }
    }
  }), _vm._v(" "), (_vm.stage !== 'prod') ? _c('span', {
    class: _vm.stageToClass[_vm.stage]
  }, [_vm._v("[" + _vm._s(_vm.stage) + "]")]) : _vm._e(), _vm._v(" "), _c('img', {
    class: _vm.$style.logo,
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" ISRS Backoffice\n    ")], 1)], 1), _vm._v(" "), _c('v-main', [(_vm.complete) ? _c('router-view') : _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-6a984028"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 941
// module chunks = 1